import { render, staticRenderFns } from "./bootUpOrder.vue?vue&type=template&id=4fa35f56&scoped=true&"
import script from "./bootUpOrder.vue?vue&type=script&lang=js&"
export * from "./bootUpOrder.vue?vue&type=script&lang=js&"
import style0 from "./bootUpOrder.vue?vue&type=style&index=0&id=4fa35f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa35f56",
  null
  
)

export default component.exports